import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import moment from "moment";
import HeaderComponent from "../../../components/header";
import ContainerComponent from "../../../components/conatiner";
import CardHeaderBackgroundComponent from "../../../components/cardHeaderBackground";
import LoadingComponent from "../../../components/loading";
import InputComponent from "../../../components/input";
import CardInfoComponent from "../../../components/cardInfo";
import TableComponent from "../../../components/table";
import { urlMobile } from "../../../services";
import ModalComponent from "../../../components/modal";
import { ToastErro } from "../../../components/toast";
import { ManagersShowOrderService } from "../../../services/managers/orders";
import OrderPDF from "../../pdf/order";
import { isBusinessCard } from "../../../components/businessCardBadge";

const ManagersInfoOrdersPage = () => {

    const navigate = useNavigate();

    const { id } = useParams();

    const [loading, setLoading] = useState<boolean>(true);

    const [visibleSpendinTypes, setVisibleSpendinTypes] = useState<boolean>(false);
    const [visibleAdvances, setVisibleAdvances] = useState<boolean>(false);

    const [order, setOrder] = useState<any>(null);
    const [items, setItems] = useState<any>([]);
    const [advances, setAdvances] = useState<any>([]);
    const [spendingTypes, setSpendingTypes] = useState<any>([]);

    const [totalValue, setTotalValue] = useState<number>(0);
    const [totalAdvances, setTotalAdvances] = useState<number>(0);

    // função para pesquisar dados da ordem
    const getData = async () => {

        setLoading(true);

        await ManagersShowOrderService(parseInt(id!)).then(resp => {
            setOrder(resp.data.order);
            setItems(resp.data.items);
            setAdvances(resp.data.advances);
            setSpendingTypes(resp.data.spendingTypes);

            // calcular valor total
            let calcTotal: number = 0;

            resp.data.items.map((i: any) => {
                if (i.status_id == 1 || i.status_id == 2 || i.status_id == 3 || i.status_id == 7) {
                    calcTotal += i.value;
                }
            });

            setTotalValue(calcTotal);
            // calcular valor total

            // calcular valor dos adiantamentos
            let calcAdvamces: number = 0;

            resp.data.advances.map((a: any) => {
                calcAdvamces += a.value;
            });

            setTotalAdvances(calcAdvamces);
            // calcular valor dos adiantamentos
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            navigate("/managers/orders");
        });

        setLoading(false);

    }
    // função para pesquisar dados da ordem   

    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            <HeaderComponent
                title={`Informações da Ordem Nº ${id}`}
                iconButton="arrow_back"
                button="Voltar"
                onClick={() => navigate(-1)}
                button2="PDF"
                iconButton2="download"
                onClick2={() => OrderPDF(parseInt(id!), order, items, advances, spendingTypes, totalValue, totalAdvances)}
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Informações"
                    >
                        {
                            loading

                                ?

                                <LoadingComponent />

                                :

                                <>
                                    <div className="row">
                                        <InputComponent
                                            label="Data de Cadastro"
                                            col={3}
                                            defaultValue={moment(order?.created_at).format('DD/MM/YYYY')}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Status"
                                            col={3}
                                            defaultValue={order?.status}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Nível Atual de Aprovação"
                                            col={3}
                                            defaultValue={order?.level}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Quantidade de Níveis de Aprovação"
                                            col={3}
                                            defaultValue={order?.approval_levels}
                                            disabled
                                            size={"small"}
                                        />
                                    </div>
                                    <div className="row">
                                        <InputComponent
                                            label="Centro de Custo"
                                            col={6}
                                            defaultValue={order?.cost_center}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Usuário"
                                            col={6}
                                            defaultValue={order?.name}
                                            disabled
                                            size={"small"}
                                        />
                                    </div>
                                    <div className="row">
                                        <InputComponent
                                            label="Cartão Corporativo"
                                            col={3}
                                            defaultValue={isBusinessCard(order?.payment_business_card) ? 'Sim' : 'Não'}
                                            disabled
                                            size={"small"}
                                        />
                                    </div>
                                    <div className="row">
                                        <InputComponent
                                            label="CPF"
                                            col={3}
                                            defaultValue={order?.cpf}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Banco"
                                            col={3}
                                            defaultValue={order?.bank}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Agência"
                                            col={3}
                                            defaultValue={order?.agency}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Conta"
                                            col={3}
                                            defaultValue={order?.account}
                                            disabled
                                            size={"small"}
                                        />
                                    </div>
                                </>
                        }
                    </CardHeaderBackgroundComponent>

                    <div className="row gx-5">
                        <CardInfoComponent
                            title="Valor Total"
                            subtitle={totalValue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            col={4}
                            icon="payments"
                        />
                        <CardInfoComponent
                            title="Total de Adiantamentos"
                            subtitle={totalAdvances.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            col={4}
                            icon="payments"
                        />
                        <CardInfoComponent
                            title="Valor Restante"
                            subtitle={(totalValue - totalAdvances).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            col={4}
                            icon="payments"
                        />
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <TableComponent
                                title="Adiantamentos"
                                columns={['ID', 'Descrição', 'Valor', 'Responsável']}
                                loading={loading}
                                iconButton={visibleAdvances ? 'expand_less' : 'expand_more'}
                                button={visibleAdvances ? 'Ocultar' : 'Expandir'}
                                onClick={() => setVisibleAdvances(!visibleAdvances)}
                            >
                                {

                                    visibleAdvances &&

                                    advances.map((a: any) => {
                                        return (
                                            <tr key={a.id}>
                                                <td className="px-4">{a.id}</td>
                                                <td className="px-4">{a.description}</td>
                                                <td className="px-4">{parseFloat(a.value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                <td className="px-4">{a.name}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </TableComponent>
                        </div>
                        <div className="col-md-6">
                            <TableComponent
                                title="Gatos por Categoria"
                                columns={['Categoria', 'Valor']}
                                loading={loading}
                                iconButton={visibleSpendinTypes ? 'expand_less' : 'expand_more'}
                                button={visibleSpendinTypes ? 'Ocultar' : 'Expandir'}
                                onClick={() => setVisibleSpendinTypes(!visibleSpendinTypes)}
                            >
                                {

                                    visibleSpendinTypes &&

                                    spendingTypes.map((s: any) => {
                                        return (
                                            <tr key={s.id}>
                                                <td className="px-4">{s.type}</td>
                                                <td className="px-4">{parseFloat(s.value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </TableComponent>
                        </div>
                    </div>
                    <TableComponent
                        title="Itens da Ordem"
                        columns={['Nº do Item', 'Categoria', 'Status', 'Data', 'Valor', 'Estado', 'Cidade', 'Modelo', 'Placa', 'Qtd.', 'Arquivo', 'Informações']}
                        loading={loading}
                    >
                        {
                            items.map((i: any) => {
                                return (
                                    <tr key={i.id}>
                                        <td className="px-4">{i.id}</td>
                                        <td className="px-4">{i.type}</td>
                                        <td className="px-4">
                                            {
                                                i.status == 'Aprovado'

                                                    ?

                                                    <h6><span className="badge bg-info">{i.status}</span></h6>

                                                    :

                                                    i.status == 'Pago'

                                                        ?

                                                        <h6><span className="badge bg-success">{i.status}</span></h6>

                                                        :

                                                        i.status == 'Pendente de Aprovação'

                                                            ?

                                                            <h6><span className="badge bg-warning">{i.status}</span></h6>

                                                            :

                                                            i.status == 'Pendente de Aprovação'

                                                                ?

                                                                <h6><span className="badge bg-warning">{i.status}</span></h6>

                                                                :

                                                                i.status == 'Reprovado'

                                                                    ?

                                                                    <h6><span className="badge bg-danger">{i.status}</span></h6>

                                                                    :

                                                                    <h6><span className="badge bg-danger">{i.status}</span></h6>
                                            }
                                        </td>
                                        <td className="px-4">{moment(i.date).format('DD/MM/YYYY')}</td>
                                        <td className="px-4">{parseFloat(i.value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                        <td className="px-4">{i.uf}</td>
                                        <td className="px-4">{i.city}</td>
                                        <td className="px-4">{i.vehicle_model ?? '--'}</td>
                                        <td className="px-4">{i.license_plate ?? '--'}</td>
                                        <td className="px-4">{i.amount ?? '--'}</td>
                                        <td className="px-4">
                                            <button className="btn btn-text-primary" type="button" title="Visualizar Arquivo" onClick={() => {
                                                (window as any).open(urlMobile.replaceAll('api/', 'storage') + i.file, '_blank').focus();
                                            }}>
                                                <i className="material-icons">description</i>
                                            </button>
                                        </td>
                                        <td className="px-4">
                                            <button className="btn btn-text-info" type="button" title="Informações" onClick={() => (window as any).$("#modalInfo" + i.id).modal('show')}><i className="material-icons">info</i></button>
                                            <ModalComponent
                                                title="Informações do Item"
                                                id={`modalInfo${i.id}`}
                                                big
                                            >
                                                <>
                                                    <div className="row mt-4">
                                                        <InputComponent
                                                            label="Nº do Item"
                                                            col={4}
                                                            defaultValue={i.id}
                                                            disabled
                                                        />
                                                        <InputComponent
                                                            label="Categoria"
                                                            col={4}
                                                            defaultValue={i.type}
                                                            disabled
                                                        />
                                                        <InputComponent
                                                            label="Status"
                                                            col={4}
                                                            defaultValue={i.status}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="row">
                                                        <InputComponent
                                                            label="Descrição"
                                                            col={12}
                                                            defaultValue={i.rdi_description}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="row">
                                                        <InputComponent
                                                            label="Data"
                                                            col={6}
                                                            defaultValue={moment(i.date).format("DD/MM/YYYY")}
                                                            disabled
                                                        />
                                                        <InputComponent
                                                            label="Valor"
                                                            col={6}
                                                            defaultValue={parseFloat(i.value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="row">
                                                        <InputComponent
                                                            label="Estado"
                                                            col={6}
                                                            defaultValue={i.uf}
                                                            disabled
                                                        />
                                                        <InputComponent
                                                            label="Cidade"
                                                            col={6}
                                                            defaultValue={i.city}
                                                            disabled
                                                        />
                                                    </div>
                                                    {
                                                        parseInt(i.type_id) == 1 || parseInt(i.type_id) == 5

                                                            ?

                                                            <>
                                                                <div className="row">
                                                                    <InputComponent
                                                                        label="Modelo"
                                                                        col={4}
                                                                        defaultValue={i.vehicle_model}
                                                                        disabled
                                                                    />
                                                                    <InputComponent
                                                                        label="Placa"
                                                                        col={4}
                                                                        defaultValue={i.license_plate}
                                                                        disabled
                                                                    />
                                                                    <InputComponent
                                                                        label="Quilometragem"
                                                                        col={4}
                                                                        defaultValue={i.mileage}
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div className="row">
                                                                    <InputComponent
                                                                        label="Quantidade"
                                                                        col={i.type_id == 1 ? 4 : 12}
                                                                        defaultValue={i.amount}
                                                                        disabled
                                                                    />
                                                                    {
                                                                        i.type_id == 1 &&

                                                                        <>
                                                                            <InputComponent
                                                                                label="Valor por Litro"
                                                                                col={4}
                                                                                defaultValue={(i.value / i.amount).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                                                                disabled
                                                                            />
                                                                            <InputComponent
                                                                                label="Tipo de Combustível"
                                                                                col={4}
                                                                                defaultValue={i.type_fuel}
                                                                                disabled
                                                                            />
                                                                        </>
                                                                    }
                                                                </div>
                                                            </>

                                                            :

                                                            <>
                                                            </>
                                                    }
                                                </>
                                            </ModalComponent>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>
                </>
            </ContainerComponent>
        </>
    );

}

export default ManagersInfoOrdersPage;